import React, { useEffect, useState } from "react"
import { Box, TextField, MenuItem, Button, Grid, Typography, Paper, useMediaQuery } from "@mui/material"
import { useTheme } from "@emotion/react"
import { styled } from "@mui/system"
import { useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import CustomBackdrop from "../../../components/CustomBackdrop"
import { Modal } from "react-bootstrap"

const Section = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(4),
  position: "relative",
  border: "1px solid #0072B1",
}))

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: "-0.75em",
  left: "1em",
  backgroundColor: theme.palette.background.paper,
  // padding: `0 ${theme.spacing(2)}px`,
  padding: "0 16px",
}))

const FlexRow = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: "column", // Default to column
  [theme.breakpoints.up("md")]: {
    flexDirection: "row", // Change to row on medium screens and up
  },
}))

const tipoIdentificacionOptions = [
  { value: "C", label: "Cédula" },
  { value: "R", label: "RUC" },
  { value: "P", label: "Pasaporte" },
]

const ModalCreateClient = ({ handleCloseModalCreateClient, cabeceraProforma, setCabeceraProforma }) => {
  const [isLoadingCreatingCliente, setIsLoadingCreatingCliente] = useState(false)
  const [formData, setFormData] = useState({
    codigo: "", // Codigo cliente generado o ya buscado
    tipoIdentificacion: "",
    nIdentificacion: "",
    nombre: "",
    direccion: "",
    telefono1: "",
    telefono2: "",
    fax: "",
    celular: "",
    email: "",
    // ruc: "",
    // razonSocial: "",
  })
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const resetModalCliente = async () => {
    await refetchCodigoClienteGenerated()
    setFormData((prev) => ({
      ...prev,
      codigo: fetchedCodigoClienteGenerated,
      tipoIdentificacion: "",
      nombre: "",
      direccion: "",
      telefono1: "",
      telefono2: "",
      fax: "",
      celular: "",
      email: "",
      // ruc: "",
      // razonSocial: "",
    }))
  }

  // -------------------------------------------
  //               QUERYS
  // -------------------------------------------
  const {
    data: fetchedFormData = {},
    isError: isLoadingFormDataError,
    isFetching: isFetchingFormData,
    isLoading: isLoadingFormData,
    refetch: refetchFormData,
    error: formDataError,
  } = useGetFormData()

  function useGetFormData() {
    return useQuery({
      queryKey: ["FormDataProformaExisted"],
      queryFn: async () => {
        // send api request here
        let response = await fetchwrapper(`/proformas/getClienteWithNumIndentificacion/${formData.nIdentificacion}`)
        response = await response.json()
        response = response?.data
        if (Object.keys(response).length === 0 || !response) {
          await resetModalCliente()
        }
        return response
      },
      refetchOnWindowFocus: false,
      enabled: false,
    })
  }

  const {
    data: fetchedCodigoClienteGenerated = "",
    isError: isLoadingCodigoClienteGeneratedError,
    isFetching: isFetchingCodigoClienteGenerated,
    isLoading: isLoadingCodigoClienteGenerated,
    refetch: refetchCodigoClienteGenerated,
  } = useGetCodigoClienteGenerated()

  function useGetCodigoClienteGenerated() {
    return useQuery({
      queryKey: ["useGetCodigoClienteGeneratedProformaCliente"],
      queryFn: async () => {
        // send api request here
        let response = await fetchwrapper(`/proformas/getLastClienteCodigoAvaliable`)
        response = await response.json()
        const codigoClienteResponse = response?.data?.clienteCodigoGenerated

        return codigoClienteResponse ?? ""
      },
      refetchOnWindowFocus: false,
      enabled: false,
    })
  }
  // -------------------------------------------

  useEffect(() => {
    refetchCodigoClienteGenerated()
  }, [])

  useEffect(() => {
    if (fetchedCodigoClienteGenerated) {
      setFormData((prev) => ({
        ...prev,
        codigo: fetchedCodigoClienteGenerated,
      }))
    }
  }, [fetchedCodigoClienteGenerated])

  useEffect(() => {
    if (fetchedFormData && Object.keys(fetchedFormData).length !== 0) {
      setFormData(() => ({
        codigo: fetchedFormData.clicodigo,
        tipoIdentificacion: fetchedFormData.cliidentifica,
        nIdentificacion: fetchedFormData.cliruc,
        nombre: fetchedFormData.clinombre,
        direccion: fetchedFormData.clidirec,
        telefono1: fetchedFormData.clitelef1,
        telefono2: fetchedFormData.clitelef2,
        fax: fetchedFormData.clifax,
        celular: "",
        email: fetchedFormData.cliemail,
        ruc: fetchedFormData.clirucmatriz,
        razonSocial: fetchedFormData.clinommatriz,
      }))
    }
  }, [fetchedFormData])

  useEffect(() => {
    if (formDataError?.error) {
      alert("No se pudo hacer la consulta si ese número de identificación existe en la base de datos")
    }
  }, [formDataError?.error])

  const handleSubmit = async (e) => {
    const { tipoIdentificacion, nIdentificacion, nombre, direccion, telefono1, telefono2, celular, fax, email } =
      formData

    // -----VERIFICACIONES-----
    const regexExpression = /^[0-9]+$/

    if (!regexExpression.test(nIdentificacion)) return alert("El número de identificacion no es válido")

    if (!nIdentificacion || !tipoIdentificacion) return alert("Complete los campos de identificación")

    if (tipoIdentificacion === "C" && nIdentificacion.length !== 10)
      return alert("Digite correctamente el número de cédula")
    if (tipoIdentificacion === "R" && nIdentificacion.length !== 13) return alert("Digite correctamente el ruc")

    // -----SAVE CLIENTE-----

    try {
      setIsLoadingCreatingCliente(true)
      // Aquí se envia los datos del cliente al backend para procesarlos
      const request = {
        cliidentifica: tipoIdentificacion,
        cliruc: nIdentificacion,
        clinombre: nombre,
        clidirec: direccion,
        clitelef1: telefono1,
        clitelef2: telefono2,
        celular,
        clifax: fax,
        cliemail: email,
        clirucmatriz: nIdentificacion,
        clinommatriz: nombre,
      }
      const options = {
        method: "POST",
        body: JSON.stringify(request),
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      }
      let result = await fetchwrapper("/proformas/createCliente", options)
      result = await result.json()
      console.log({ clinombre: nombre, clicodigo: result.clicodigo }, "aquii")
      setCabeceraProforma({
        ...cabeceraProforma,
        clinombre: nombre,
        clicodigo: result.clicodigo,
      })

      alert("Cliente procesado correctamente")

      // Limpia el formulario después de enviar los datos
      //   clearModalCreateClient();
      setFormData({})

      // Cerrar el modal
      handleCloseModalCreateClient()
    } catch (err) {
      console.log(err)
      alert("No se pudo crear el cliente")
    } finally {
      setIsLoadingCreatingCliente(false)
    }

    console.log(formData, tipoIdentificacion)
  }

  const handleBlurOrEnter = (e) => {
    if (e.type === "blur" || (e.type === "keypress" && e.key === "Enter")) {
      if (!formData.nIdentificacion) return
      refetchFormData()
    }
  }
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <>
      <CustomBackdrop
        isLoading={
          isLoadingFormData ||
          isFetchingFormData ||
          isLoadingCodigoClienteGenerated ||
          isFetchingCodigoClienteGenerated ||
          isLoadingCreatingCliente
        }
        zIndex={1000000}
      />
      <Box
        sx={{
          p: 2,
          maxHeight: isMobile ? "90vh" : "auto", // Limit height on mobile
          overflowY: isMobile ? "auto" : "visible", // Enable scrolling on mobile
        }}
      >
        <Section elevation={3}>
          <SectionTitle variant="h6">Datos Generales</SectionTitle>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  label="Código"
                  name="codigo"
                  value={formData.codigo}
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: "#f0f0f0" }, // Fondo gris para indicar que está bloqueado
                  }}
                  fullWidth
                  variant="outlined"
                  disabled
                />
                <TextField
                  select
                  label="Tipo de Identificación"
                  name="tipoIdentificacion"
                  value={formData.tipoIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                >
                  {tipoIdentificacionOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                <TextField
                  label="Número de Identificación"
                  name="nIdentificacion"
                  value={formData.nIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  onBlur={handleBlurOrEnter}
                  onKeyPress={handleBlurOrEnter}
                  autoComplete="off"
                />
              </FlexRow>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Nombre"
                name="nombre"
                value={formData.nombre}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Dirección"
                name="direccion"
                value={formData.direccion}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Grid>
            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  label="Teléfono 1"
                  name="telefono1"
                  value={formData.telefono1}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
                <TextField
                  label="Teléfono 2"
                  name="telefono2"
                  value={formData.telefono2}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </FlexRow>
            </Grid>

            <Grid item xs={12}>
              <FlexRow>
                <TextField
                  label="Celular"
                  name="celular"
                  value={formData.celular}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
                <TextField
                  label="Fax"
                  name="fax"
                  value={formData.fax}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </FlexRow>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                fullWidth
                variant="outlined"
                autoComplete="off"
              />
            </Grid>
          </Grid>
          <br />
          <br />

          {/* <Section elevation={3}>
            <SectionTitle variant="h6">Datos Matriz</SectionTitle>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="RUC"
                  name="nIdentificacion"
                  value={formData.nIdentificacion}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Razón Social"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  fullWidth
                  variant="outlined"
                  autoComplete="off"
                />
              </Grid>
            </Grid>
          </Section> */}

          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#114B5E", color: "white" }}
              fullWidth
              onClick={() => handleSubmit()}
            >
              Guardar
            </Button>
          </Grid>
        </Section>
      </Box>
    </>
  )
}

export default ModalCreateClient
